<template>
	<v-card elevation="0">
		<message-maker v-if="isMessageCreateActive()" ref="mmFocus"></message-maker>
		<email-subscribers v-if="isSubscribersActive()" ref="esFocus"></email-subscribers>
		<message-history v-if="isMessageHistoryActive()" ref="mhFocus"></message-history>
		<v-divider></v-divider>
		<v-card-actions>
			<v-btn class="btn-default" text @click="showSubscribers" :disabled="isSubscribersActive()">Subscriber List</v-btn>
			<v-spacer></v-spacer>
			<v-btn class="btn-default" @click="showMessageCreate" text :disabled="isMessageCreateActive()">Create</v-btn>
			<v-spacer></v-spacer>
			<v-btn class="btn-default" text @click="showMessageHistory" :disabled="isMessageHistoryActive()">History</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import emailSubscribers from './Messages/emailSubscribers.vue'
import messageMaker from './Messages/messageMaker.vue'
import messageHistory from './Messages/messageHistory.vue'

export default {
	components: { messageMaker, messageHistory, emailSubscribers },
	name: 'Messages',
	data () {
		return {
			// Define constants inside the data object so they can be used in the template
			COMPONENT_SUBSCRIBER_LIST: 'emailSubscribers',
			COMPONENT_MESSAGE_CREATE: 'messageMaker',
			COMPONENT_MESSAGE_HISTORY: 'mHistory',

			activeComponent: null
		}
	},
	mounted () {
		// Set the active component to the default
		this.activeComponent = this.COMPONENT_MESSAGE_CREATE
	},
	methods: {
		showSubscribers () {
			this.activeComponent = this.COMPONENT_SUBSCRIBER_LIST;
		},
		showMessageCreate () {
			this.activeComponent = this.COMPONENT_MESSAGE_CREATE;
		},
		showMessageHistory () {
			this.activeComponent = this.COMPONENT_MESSAGE_HISTORY;
		},
		isSubscribersActive () {
			return this.activeComponent === this.COMPONENT_SUBSCRIBER_LIST;
		},
		isMessageCreateActive () {
			return this.activeComponent === this.COMPONENT_MESSAGE_CREATE;
		},
		isMessageHistoryActive () {
			return this.activeComponent === this.COMPONENT_MESSAGE_HISTORY;
		}
	}
}
</script>

<style>

</style>
